import { Configuration } from '@wallets/sdk';

export const initializeCyberSource = () => {
    Configuration.initialize({
        CYB_MICROFORM_V2_URL_JS:
            'https://flex.cybersource.com/microform/bundle/v2/flex-microform.min.js',
        PHUB_V2_URL:
            process.env.REACT_APP_STAGE === 'prod'
                ? 'https://api.ripley.com/marketplace/ecommerce/checkout/payments-hub/v3/payments'
                : 'https://api-qa.ripley.com/marketplace/ecommerce/checkout/payments-hub/v3/payments',
        DEBUG_MODE: process.env.REACT_APP_STAGE === 'prod' ? false : true,
        SEND_SDK_LOGS: true,
    });
};
